export default "__VITE_ASSET__QYKG7Qkg__"